import * as actions from '../actionsTypes/user';


export default (state = {}, { type, payload }) => {
    switch (type) {
        case actions.GET_USER_DATA: return payload;
        default: return state;
    }
}